import React from 'react';
import "./breadcrumb.css"
import DPRImg from "../../assets/Icons/dpricon.png"

const DprHeader = (props) => {
  
    return <React.Fragment>
        <div className='card card-dpr'>
            <div className='card-body'>
            <div className='d-flex justify-content-between pb-0'>
            <div className='my-auto'>
                <img src={DPRImg} width={90} height={35} />
            </div>
            <div className='my-auto'>
                <div style={{fontSize:12,fontWeight:500,color:"rgb(84 83 83)"}}>
                {props?.project?.PO_No}
                </div>
                <div style={{color:"rgba(29, 103, 180, 1)",fontSize:14,fontWeight:600}}>
                {props?.project?.Project_Name}
                </div>
                <div style={{fontSize:12,fontWeight:500,color:"rgba(29, 103, 180, 1)"}}>
                {props?.project?.ProjectOwnerName}
                </div>
            </div>
        </div>
            </div>
        </div>
    </React.Fragment>
};

export default DprHeader;


